import { memo, ReactNode } from 'react'
import './index.scss'
import { useTranslation } from 'react-i18next'
import Image from '../Image'
import { DateTime } from 'luxon'
import ImageGallery from '../ImageGallery'

export type DisplayData = {
  label: string
  value: string | number | ReactNode
  type?: string
}

type InfoDisplay = {
  label?: string
  data: DisplayData[]
}

const InfoDisplay = memo(({ label, data = [] }: InfoDisplay) => {
  const { t } = useTranslation()

  return (
    <div className="InfoDisplay">
      {!!label && (
        <div className="InfoDisplay__label">{label}</div>
      )}
      {data.map((d) => {
        const { label: dLabel, value, type } = d
        let formatValue = value ?? t('None')
        if (Array.isArray(formatValue)) formatValue = formatValue.join(', ')
        
        if (type === 'img') {
          if (Array.isArray(value)) {
            return (
              <div className="InfoDisplay__data img">
                <ImageGallery values={value} />
              </div>
            )
          }

          return (
            <div className="InfoDisplay__data img">
              <div className="InfoDisplay__data-label">{dLabel}</div>
              <Image url={value} />
            </div>
          )
        } else if (type === 'datetime') {
          formatValue = DateTime.fromISO(value as string).toLocaleString(DateTime.DATETIME_MED)
        }

        return (
          <div className="InfoDisplay__data">
            <div className="InfoDisplay__data-label">{dLabel}</div>
            <div className="InfoDisplay__data-value">{formatValue}</div>
          </div>
        )
      })}
    </div>
  )
})

export default InfoDisplay
